import React from "react";

function DetailsPage() {
  return <div>detailspage</div>;
}

export default DetailsPage;
